/* Link-click events for the "GA4 lead & checkout events" custom pixel (2026-09-22).
   Shopify's own `clicked` event reports the innermost element (the text inside a link), which has no href,
   so a tap on "Call 812-201-5900" never reached the pixel. This finds the actual link and publishes it. */
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest && e.target.closest('a[href]');
  if (!a || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
  Shopify.analytics.publish('st_link_click', { href: a.href || a.getAttribute('href') || '' });
}, true);
